import { del, get, post, put } from "./api_helper";
import * as url from "./url_helper";

const getAlerts = (token, clubId) => {
  return get(url.ALERTS_BY_CLUB(clubId), {
    headers: {
      Authorization: token,
    },
  });
};

const deleteAlert = (token, id) => {
  return del(url.DELETE_ALERT(id), {
    headers: {
      Authorization: token,
    },
  });
};

const updateAlert = (token, data) => {
  return put(url.ALERTS, data, {
    headers: {
      Authorization: token,
    },
  });
};

const addAlert = (token, data) =>
  post(url.ALERTS, data, {
    headers: {
      Authorization: token,
    },
  });

export { getAlerts, addAlert, deleteAlert, updateAlert };
